var _use, _use2, _use3, _image, _image2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconValue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 67 67",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.227,
    cy: 33.242,
    rx: 33.227,
    ry: 33.242,
    style: {
      fill: "url(#_Linear1)"
    }
  }), /*#__PURE__*/React.createElement("g", null, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image2",
    x: 19.023,
    y: 13.729,
    width: "31.651px",
    height: "43.431px",
    transform: "matrix(0.989091,0,0,0.987074,0,0)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.898,25.06c-0.029,-3.077 -3.553,-6.377 -8.454,-6.377c-4.9,0 -8.455,2.715 -8.415,6.422c0.126,11.844 17.332,5.793 17.479,16.699c0.051,3.845 -3.629,7.218 -9.064,7.218c-5.435,0 -9.499,-2.252 -9.498,-7.218",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: "3.07px"
    }
  }), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image3",
    x: 25.711,
    y: 10.467,
    width: "14px",
    height: "49.326px",
    transform: "matrix(1,0,0,0.986524,0,0)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31.297,13.939l0,39.272",
    style: {
      fill: "url(#_Linear4)",
      stroke: "#fff",
      strokeWidth: 2
    }
  }), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image3",
    x: 30.022,
    y: 10.467,
    width: "14px",
    height: "49.326px",
    transform: "matrix(1,0,0,0.986524,0,0)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.607,13.939l0,39.272",
    style: {
      fill: "url(#_Linear5)",
      stroke: "#fff",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.898,25.06c-0.029,-3.077 -3.553,-6.377 -8.454,-6.377c-4.9,0 -8.455,2.715 -8.415,6.422c0.126,11.844 17.332,5.793 17.479,16.699c0.051,3.845 -3.629,7.218 -9.064,7.218c-5.435,0 -9.499,-2.252 -9.498,-7.218",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: "3.07px"
    }
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(33.2269,66.4836,-66.4836,33.2269,33.2269,1.13687e-13)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffd0fa",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e4c3ff",
      stopOpacity: 1
    }
  })), _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "_Image2",
    width: "32px",
    height: "44px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAsCAYAAAAEuLqPAAAACXBIWXMAAA7EAAAOxAGVKw4bAAACzklEQVRYhaVYwXHDMAyjY6+RZyfIqyt0j07VPbpCf12g346R2H3EdCEIkJSWdzo7tiSCIEUynuIBeX55nUbnfry/bSPzuhuSUnefstG1C8QCAMV4Vc+U4o2fOSASAClvDRRUuAKIA4wCUQEg5SdzdQBwrAoIgyg2EcrVGAGwiiFBnJgBoXzexwL3swA209yF5h6gMbAXsh4Hb8qWq6A6gaU59wbv1/3ZMANsbS5u+XnEfQcLi7DeLgod4QycjyuyssL77QBAmyggqHyNO60M4LS/Q5/zntWpYwCIGjdBALd9JBO5ZgVrE0REzVKXASXueHHAcQacaH2VqhUDThQIVjYCoDg9jwBIcSk4ZRUA8nkXAG+Gm2RspK9RGa9PZRxDFQuKAaQ5g4pPxkbzVTVkgwrFmY4XMYETzby/x+yYGW6CeRgHSjk/i8jNv78+4/x0cfWfz7B6roqU6xWKsqxckNkKs1ZEmRewPKf16soMVD0B1wKk/hZl0uHE46olV0FbCSN+/avc4JKSc4erH5Wcny7T99dnzQDQo1jgwYy0WKl6ghRVjhOAcsd1H841CYZ7CWanLMcpou9XiQXLaqtndAYWx/VQKNrwEL9bR1D1EQkeGUTm7kFo2nAux2iBSquu7Kq1h6ALXOJxlYyrXY8pCWoG65FKjloXG6oxTQCqnatYW2BBgmAfYlbjiGcQtu47Y5wLuBdkBrDm/0tcT4gUKgAMjIG3ArBwn+uIbNDAM7a+184PNSQcXLkB/jO6RdnrIyhMxV3lCIBTb5ZZV/N5s948+Sc1ImI2VVC5gI+ryn4t5VjAtoh78VMtGTciqRTFlVtnNSs/3KBashFxc7l4peKqcqqmlDfI31voBNU6ZsxA4X/5gYKaEfYd9gJX8fvamFf5HqWi8o8fqFosFEe7+Y1IgEAg6h4VKxBWcRNAA0hvXfM/wMMAGmC6Mvqp9gdiZsGT4g8+ngAAAABJRU5ErkJggg=="
  })), _image2 || (_image2 = /*#__PURE__*/React.createElement("image", {
    id: "_Image3",
    width: "14px",
    height: "50px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAyCAYAAABs8OoHAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAA2UlEQVRIie2WsRXCMAxETyFrUDIBVVbIHpkqe2SFdCxAyxwRDQ7SWTYuKO33XFjWv5NdnYDWNC/CNQDYt1Xt2TUZiOETSgJjAYpcneOlAAmAIRK43u7yej6+jgFk6wrgsM4jfYZ1EttoBODeWBkzuYmFRwNFAgjuMc2L2LeUBHgJ4D+hJpC5RmDR5RfYtDrYwQ52sIMd/AeoLTUGNWiMai4DtDhnoMKHBXZ0531bdTAZTc0+aCsL8KgJGsjlQOWN3MijO8czFHwSVi09KhCkx8C1Ws9iSGvQfQOBrU1DUUORbgAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear4",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(31.4528,66.4836,-66.4836,31.4528,10.9368,5.81757e-13)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e4c3ff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    style: {
      stopColor: "#c0ccff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b5cfff",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear5",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(31.4528,66.4836,-66.4836,31.4528,10.9368,5.81757e-13)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e4c3ff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    style: {
      stopColor: "#c0ccff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b5cfff",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconValue);
export default __webpack_public_path__ + "static/media/icon-value.bfd16d490e74fe80c9f42ff901878104.svg";
export { ForwardRef as ReactComponent };